export const supportedLanguages = ['hy', 'en', 'ru'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const sourceLanguage: SupportedLanguage = 'hy';

export const resources = {
  hy: {
    translation: {
      startup: {
        title: 'Չհաջողվեց բացել հավելվածը',
        description:
          'Ստուգեք ինտերնետ կապը և կրկին փորձեք։ Եթե խնդիրը շարունակվի, դիմեք աջակցման ծառայությանը։',
        retry: 'Կրկին փորձել',
        loading: 'Բեռնվում է...',
      },
      app: {
        title: 'Trio Waiter',
        summary:
          'Հեռախոսով սեղանների QR կոդերը կառավարելու գործիք ռեստորանի աշխատակիցների համար։',
        onlineReady: 'Կապը վերականգնվել է։ Կարող եք կառավարել QR կոդերը։',
        offlineMessage: 'QR կոդերը կառավարելու համար կապ է պետք։',
        offlineSubMessage: 'Հավելվածը կվերսկսվի, երբ կապը վերականգնվի։',
      },
      language: {
        label: 'Լեզու',
        option: {
          hy: 'Հայերեն',
          en: 'English',
          ru: 'Русский',
        },
      },
      home: {
        title: 'Ընտրել կազմակերպությունը',
        manageAction: 'Կառավարել',
        doneAction: 'Պատրաստ է',
        removeAction: 'Հեռացնել պահպանված մուտքը',
        managingHint:
          'Քաշեք բռնակը՝ մուտքերը վերադասավորելու համար, կամ օգտագործեք սլաքների ստեղները։ Մուտքը հեռացնելու համար սեղմեք աղբամանի կոճակը։',
        managingSingleHint:
          'Այս մուտքը հեռացնելու համար սեղմեք աղբամանի կոճակը։',
        removeConfirmationSheet: {
          title: 'Հեռացնե՞լ պահպանված մուտքը',
          description:
            '«{{organizationName}} · {{operatorName}}» մուտքը կհեռացվի միայն այս սարքից։',
          cancelAction: 'Չեղարկել',
          removeAction: 'Հեռացնել',
        },
        description:
          'Պահպանված մուտքերը մնում են այս սարքում։\nՇարունակելու համար անհրաժեշտ է մուտքագրել PIN-ը։',
        languageSwitchAriaLabel: 'Փոխել լեզուն՝ {{language}}',
        savedLoginCard: {
          ariaLabel: 'Բացել {{organizationName}} մուտքը',
          checkingStatus: 'Պահպանված մուտքը ստուգվում է...',
          invalidMessage:
            'Այս մուտքն այլևս վավեր չէ։ Օգտագործելու համար սկանավորեք մուտքի նոր QR կոդ։',
          invalidScanAction: 'Սկանավորել նոր մուտքի QR',
          invalidRemoveAction: 'Հեռացնել',
          lockedStatus: 'Մուտքը փակված է ևս {{time}}',
          reorderAction: 'Վերադասավորել {{organizationName}} մուտքը',
          reorderHint: 'Քաշեք կամ օգտագործեք վերև և ներքև սլաքների ստեղները',
          movedAnnouncement:
            '{{organizationName}}-ը տեղափոխվեց {{position}}-րդ դիրք՝ {{total}}-ից։',
        },
        addLoginCard: {
          title: 'Ավելացնել այլ մուտք',
          subtitle: 'Սկանավորել QR կոդը',
          ariaLabel: 'Ավելացնել այլ մուտք և սկանավորել QR կոդը',
        },
        empty: {
          title: 'Պահպանված մուտքեր չկան',
          description:
            'Սկանավորեք օպերատորի մուտքի QR կոդը՝ այս սարքում կազմակերպություն ավելացնելու համար։',
        },
        tables: {
          title: 'Սեղաններ',
          hallsLabel: 'Դահլիճներ',
          findByQrAction: 'Գտնել սեղանը QR-ով',
          findScannerSubtitle: 'Սեղանի որոնում',
          findScannerInstruction: 'Սկանավորեք սեղանի QR-ը',
          findScannerDescription: 'Սեղանը կընտրվի իր դահլիճում։',
          invalidFindQr: 'Սա սեղանի QR կոդ չէ։',
          qrTableNotFound: 'Այս QR կոդին կցված սեղան չի գտնվել։',
          noQrAttached: 'Կցված QR կոդ չկա',
          loading: 'Սեղանները բեռնվում են...',
          tableNoLongerExists:
            'Այս սեղանն այլևս հասանելի չէ։ Սեղանների ցանկը թարմացվել է։',
          noTablesFound: 'Սեղաններ չեն գտնվել',
          attachedQrs: 'Կցված QR-ներ',
          attachedQrListAriaLabel: 'Կցված սեղանի QR-ներ',
          qrImageAriaLabel: '{{sequenceNumber}} QR կոդ',
          detailBackAction: 'Վերադառնալ սեղաններին',
          removeAction: 'Հեռացնել',
          removeQrAriaLabel: 'Հեռացնել {{sequenceNumber}} QR-ը',
          attachAction: 'Կցել QR',
          dismissNoticeAction: 'Փակել կարգավիճակը',
          attachSuccess: '{{sequenceNumber}} QR-ը կցվել է {{tableName}}-ին։',
          invalidTableQr: 'Սա սեղանի QR կոդ չէ։',
          invalidTableQrDescription:
            'Սկանավորեք սեղանի կարգավորման համար ստեղծված QR կոդը։',
          alreadyAttached: '{{sequenceNumber}} QR-ն արդեն կցված է այս սեղանին։',
          alreadyAttachedDialog: {
            title: '{{sequenceNumber}} QR-ն արդեն կցված է {{tableName}}-ին',
            description: 'Փոփոխություններ չեն կատարվել։',
            acknowledgeAction: 'Հասկացա',
          },
          moveConfirmationSheet: {
            title: 'Տեղափոխե՞լ {{sequenceNumber}} QR-ը',
            alreadyAttachedDescription: 'Այս QR կոդն արդեն կցված է այլ սեղանի։',
            message:
              'Հեռացնե՞լ {{sequenceNumber}} QR-ը {{fromHallName}} / {{fromTableName}}-ից և կցել {{toHallName}} / {{toTableName}}-ին։',
            fromLabel: '{{fromHallName}} / {{fromTableName}}',
            fromHeading: 'Ընթացիկ սեղան',
            summaryLabel: 'Տեղափոխման ամփոփում',
            toLabel: '{{toHallName}} / {{toTableName}}',
            toHeading: 'Նոր սեղան',
            cancelAction: 'Չեղարկել',
            moveAction: 'Տեղափոխել QR',
          },
          moveConflictSheet: {
            title: '{{sequenceNumber}} QR-ը չի տեղափոխվել',
            description:
              'Մինչ դուք աշխատում էիք, QR-ի կցումը փոխվել է։ {{sequenceNumber}} QR-ն այժմ կցված է {{tableName}}-ին։ Սեղանների վերջին տվյալները բեռնվել են։',
            changedBy: 'Վերջին փոփոխությունը կատարել է {{userName}}-ը',
            changedAt: 'Վերջին փոփոխության ժամը՝ {{dateTime}}',
            acknowledgeAction: 'Հասկացա',
          },
          removeConfirmationSheet: {
            title: 'Հեռացնե՞լ {{sequenceNumber}} QR-ը {{tableName}}-ից',
            description:
              'QR կոդը կհեռացվի սեղանից։ Հետագայում այն կրկին հնարավոր կլինի կցել։',
            cancelAction: 'Չեղարկել',
            removeAction: 'Հեռացնել',
          },
          removeSuccess: '{{sequenceNumber}} QR-ը հեռացվել է {{tableName}}-ից։',
          removeFailed: 'Չհաջողվեց հեռացնել QR-ը։ Կրկին փորձեք։',
          moveSuccess:
            '{{sequenceNumber}} QR-ը տեղափոխվել է {{fromTableName}}-ից {{toTableName}}։',
          moveFailed: 'Չհաջողվեց տեղափոխել QR-ը։ Կրկին փորձեք։',
          moveConflict: 'QR-ի կցումը փոխվել է։ Սեղանի տվյալները թարմացվել են։',
          openTableAriaLabel: 'Բացել {{tableName}}-ը',
          hallTabsAriaLabel: 'Ընտրել դահլիճը',
          tableListAriaLabel: '{{hallName}}-ի սեղաններ',
        },
        scanner: {
          closeAction: 'Փակել սկաները',
          scanLoginHint: 'Ուղղեք տեսախցիկը QR կոդի վրա։',
          loginHeaderSubtitle: 'Կարգավորման օպերատորի մուտք',
          tableHeaderSubtitle: 'Կցել սեղանին',
          tableContextLabel: 'Կցել՝ {{hallName}} · {{tableName}}',
          loginTitle: 'Սկանավորել մուտքի QR-ը',
          loginDescription:
            'Սկանավորեք ռեստորանի կառավարման համակարգում ստեղծված օպերատորի մուտքի QR-ը։',
          loginInstructionTitle: 'Տեղավորեք մեկ մուտքի QR շրջանակի մեջ։',
          loginInstructionText: 'Սկանավորումն ավարտվում է ավտոմատ։',
          tableTitle: 'Սկանավորել սեղանի QR-ը',
          tableDescription: 'Ուղղեք տեսախցիկը սեղանի QR կոդի վրա։',
          tableInstructionTitle: 'Տեղավորեք մեկ սեղանի QR շրջանակի մեջ։',
          tableInstructionText: 'Սկանավորումն ավարտվում է ավտոմատ։',
          detectedChecking: 'QR-ը հայտնաբերվել է · Ստուգվում է…',
          detectedCheckingDescription: 'QR կոդը պահեք շրջանակի մեջ։',
          errorInstructionText: 'Սկանավորեք ճիշտ կարգավորման QR-ը։',
          invalidLoginQrDescription:
            'Սկանավորեք կառավարման համակարգի մուտքի QR-ը։',
          loginCameraNeededText:
            'Թույլ տվեք օգտագործել տեսախցիկը՝ օպերատորի մուտքի QR-ը սկանավորելու համար։',
          tableCameraNeededText:
            'Թույլ տվեք օգտագործել տեսախցիկը՝ սեղանի QR-ները սկանավորելու համար։',
          backAction: 'Ընտրել կազմակերպությունը',
          invalidLoginQr: 'Սա մուտքի QR չէ։',
          cameraNeededTitle: 'Թույլ տվեք օգտագործել տեսախցիկը',
          cameraNeededText:
            'Թույլ տվեք օգտագործել տեսախցիկը՝ մուտքի և սեղանի QR-ները սկանավորելու համար։',
          cameraFrozenTitle: 'Տեսախցիկի պատկերը սառել է',
          cameraFrozenText:
            'Փակեք տեսախցիկ օգտագործող այլ հավելվածները, հետո կրկին փորձեք։',
          tryAgain: 'Կրկին փորձել',
          flashlightOn: 'Լապտերը միացնել',
          flashlightOff: 'Լապտերը անջատել',
          cameraZoom: 'Տեսախցիկի մոտեցում',
          cameraZoomValue: '{{value}}×',
          cameraZoomAction:
            'Տեսախցիկի մոտեցում՝ {{value}}։ Հպվեք՝ վերակայելու համար։',
        },
        pin: {
          title: 'Մուտքագրեք PIN-ը',
          signedInAs: '{{name}} · {{organizationName}}',
          changeAction: 'Փոխել',
          scanAgainAction: 'Կրկին սկանավորել',
          label: 'PIN',
          verifying: 'PIN-ը ստուգվում է…',
          successMessage: 'QR կոդերի կառավարման աշխատաշրջանը սկսվեց։',
          invalidError:
            'Սխալ PIN։ Փորձ {{attempt}}/3։ {{remaining}} փորձ է մնում։',
          lockedError:
            'PIN-ը շատ անգամ սխալ է մուտքագրվել։ Կրկին փորձեք {{time}} անց։',
          pinDigitLabel: 'PIN-ի {{index}}-րդ նիշ',
          pinComponentLabel: 'Քառանիշ PIN',
          continueAutomatically: 'Մուտքը կկատարվի 4-րդ թվից հետո',
          firstRun: {
            subtitle: 'Մուտք՝ որպես {{name}}',
          },
          repeat: {
            subtitle: 'Մուտք՝ որպես {{name}}',
          },
        },
        logoutLabel: 'Դուրս գալ',
        sessionVerifying: 'Աշխատաշրջանը ստուգվում է...',
        loginQrVerifying: 'Մուտքի QR-ը ստուգվում է...',
        sessionExpired: 'Աշխատաշրջանն ավարտվել է։ Կրկին մուտք գործեք։',
      },
      notFound: {
        title: 'Էջը չի գտնվել',
        description: 'Ստուգեք հասցեն կամ վերադարձեք մեկնարկային էջին։',
      },
    },
  },
  en: {
    translation: {
      startup: {
        title: 'Unable to open the app',
        description:
          'Check your internet connection and try again. If the problem continues, contact support.',
        retry: 'Try again',
        loading: 'Loading...',
      },
      app: {
        title: 'Trio Waiter',
        summary:
          'A standalone, mobile-first tool for managing table QR codes for restaurant staff.',
        onlineReady:
          'Connection is available. QR management is ready for online work.',
        offlineMessage: 'Connection needed to manage QR codes.',
        offlineSubMessage: 'The app will resume when the connection returns.',
      },
      language: {
        label: 'Language',
        option: {
          hy: 'Հայերեն',
          en: 'English',
          ru: 'Русский',
        },
      },
      home: {
        title: 'Select organization',
        manageAction: 'Manage',
        doneAction: 'Done',
        removeAction: 'Remove saved login',
        managingHint:
          'Drag a handle to reorder logins, or use the arrow keys. Tap the trash button to remove a login.',
        managingSingleHint: 'Tap the trash button to remove this login.',
        removeConfirmationSheet: {
          title: 'Remove saved login?',
          description:
            'Remove {{organizationName}} · {{operatorName}} from this device only?',
          cancelAction: 'Cancel',
          removeAction: 'Remove',
        },
        description:
          'Saved logins stay on this device.\nYou still need the PIN to continue.',
        languageSwitchAriaLabel: 'Switch language to {{language}}',
        savedLoginCard: {
          ariaLabel: 'Open {{organizationName}} login',
          checkingStatus: 'Checking saved login...',
          invalidMessage:
            'This saved login is no longer valid. Scan a new login QR to use this organization again.',
          invalidScanAction: 'Scan new login QR',
          invalidRemoveAction: 'Remove',
          lockedStatus: 'Locked {{time}}',
          reorderAction: 'Reorder {{organizationName}} login',
          reorderHint: 'Drag or use the up and down arrow keys',
          movedAnnouncement:
            '{{organizationName}} moved to position {{position}} of {{total}}.',
        },
        addLoginCard: {
          title: 'Add another login',
          subtitle: 'Scan QR code',
          ariaLabel: 'Add another login and scan a QR code',
        },
        empty: {
          title: 'No saved logins',
          description:
            'Scan an Operator Login QR to add an organization on this device.',
        },
        tables: {
          title: 'Tables',
          hallsLabel: 'Halls',
          findByQrAction: 'Find table by QR',
          findScannerSubtitle: 'Find a table',
          findScannerInstruction: 'Scan a table QR',
          findScannerDescription: 'The table will be selected in its hall.',
          invalidFindQr: 'This is not a table QR.',
          qrTableNotFound: 'No table is attached to this QR.',
          noQrAttached: 'No QR attached',
          loading: 'Loading tables...',
          tableNoLongerExists:
            'This table is no longer available. The table list was refreshed.',
          noTablesFound: 'No tables found',
          attachedQrs: 'Attached QRs',
          attachedQrListAriaLabel: 'Attached table QRs',
          qrImageAriaLabel: 'QR code {{sequenceNumber}}',
          detailBackAction: 'Back to tables',
          removeAction: 'Remove',
          removeQrAriaLabel: 'Remove QR {{sequenceNumber}}',
          attachAction: 'Attach QR',
          dismissNoticeAction: 'Dismiss status',
          attachSuccess: 'QR {{sequenceNumber}} attached to {{tableName}}',
          invalidTableQr: 'This is not a table QR․',
          invalidTableQrDescription: 'Scan a QR created for table setup.',
          alreadyAttached:
            'QR {{sequenceNumber}} is already attached to this table.',
          alreadyAttachedDialog: {
            title: 'QR {{sequenceNumber}} is already on {{tableName}}',
            description: 'No changes were made.',
            acknowledgeAction: 'Got it',
          },
          moveConfirmationSheet: {
            title: 'Move QR {{sequenceNumber}}?',
            alreadyAttachedDescription:
              'This QR is already attached to another table.',
            message:
              'Remove QR {{sequenceNumber}} from {{fromHallName}} / {{fromTableName}} and attach it to {{toHallName}} / {{toTableName}}?',
            fromLabel: '{{fromHallName}} / {{fromTableName}}',
            fromHeading: 'From',
            summaryLabel: 'Move summary',
            toLabel: '{{toHallName}} / {{toTableName}}',
            toHeading: 'To',
            cancelAction: 'Cancel',
            moveAction: 'Move QR',
          },
          moveConflictSheet: {
            title: 'QR {{sequenceNumber}} was not moved',
            description:
              'Its assignment changed while you were working. QR {{sequenceNumber}} is currently attached to {{tableName}}. The latest table data has been loaded.',
            changedBy: 'Last changed by {{userName}}',
            changedAt: 'Last changed at {{dateTime}}',
            acknowledgeAction: 'Got it',
          },
          removeConfirmationSheet: {
            title: 'Remove QR {{sequenceNumber}} from {{tableName}}?',
            description:
              'This QR will be detached from the table and can be attached again later.',
            cancelAction: 'Cancel',
            removeAction: 'Remove',
          },
          removeSuccess: 'QR {{sequenceNumber}} removed from {{tableName}}',
          removeFailed: 'Could not remove the QR. Try again.',
          moveSuccess:
            'QR {{sequenceNumber}} moved from {{fromTableName}} to {{toTableName}}',
          moveFailed: 'Could not move the QR. Try again.',
          moveConflict: 'QR assignment changed. Table details were refreshed.',
          openTableAriaLabel: 'Open {{tableName}}',
          hallTabsAriaLabel: 'Select hall',
          tableListAriaLabel: '{{hallName}} tables',
        },
        scanner: {
          closeAction: 'Close scanner',
          scanLoginHint: 'Point the camera at the QR.',
          loginHeaderSubtitle: 'Setup operator login',
          tableHeaderSubtitle: 'Attach to table',
          tableContextLabel: 'Attach to {{hallName}} · {{tableName}}',
          loginTitle: 'Scan login QR',
          loginDescription:
            'Scan the Operator Login QR from the restaurant administration system.',
          loginInstructionTitle: 'Position one Login QR inside the frame.',
          loginInstructionText: 'Scanning completes automatically.',
          tableTitle: 'Scan table QR',
          tableDescription: 'Point the camera at the physical table QR.',
          tableInstructionTitle: 'Position one Table QR inside the frame.',
          tableInstructionText: 'Scanning completes automatically.',
          detectedChecking: 'QR detected · Checking…',
          detectedCheckingDescription: 'Keep the QR code inside the frame.',
          errorInstructionText: 'Scan the correct setup QR.',
          invalidLoginQrDescription: 'Scan the QR from the admin app.',
          loginCameraNeededText:
            'Allow camera access to scan the Operator Login QR.',
          tableCameraNeededText: 'Allow camera access to scan Table QRs.',
          backAction: 'Select organization',
          invalidLoginQr: 'This is not a login QR.',
          cameraNeededTitle: 'Camera access needed',
          cameraNeededText: 'Allow camera access to scan login and table QRs.',
          cameraFrozenTitle: 'Camera preview froze',
          cameraFrozenText:
            'Close other apps using the camera, then try again.',
          tryAgain: 'Try again',
          flashlightOn: 'Flashlight on',
          flashlightOff: 'Flashlight off',
          cameraZoom: 'Camera zoom',
          cameraZoomValue: '{{value}}×',
          cameraZoomAction: 'Camera zoom: {{value}}. Tap to reset.',
        },
        pin: {
          title: 'Enter <strong>PIN</strong>',
          signedInAs: '{{name}} · {{organizationName}}',
          changeAction: 'Change organization',
          scanAgainAction: 'Scan again',
          label: 'PIN',
          verifying: 'Verifying...',
          successMessage: 'QR setup session started.',
          invalidError:
            'Incorrect PIN. Attempt {{attempt}}/3. {{remaining}} attempts remaining.',
          lockedError:
            'Too many incorrect PIN attempts. Try again in {{time}}.',
          pinDigitLabel: 'PIN digit {{index}}',
          pinComponentLabel: '4-digit PIN',
          continueAutomatically: "You'll continue automatically",
          firstRun: {
            subtitle: 'Login as {{name}}',
          },
          repeat: {
            subtitle: 'Login as {{name}}',
          },
        },
        logoutLabel: 'Log out',
        sessionVerifying: 'Verifying session...',
        loginQrVerifying: 'Checking login QR...',
        sessionExpired: 'Session expired. Please sign in again.',
      },
      notFound: {
        title: 'Page not found',
        description: 'Check the address or return to the start page.',
      },
    },
  },
  ru: {
    translation: {
      startup: {
        title: 'Не удалось открыть приложение',
        description:
          'Проверьте подключение к интернету и попробуйте снова. Если проблема повторится, обратитесь в поддержку.',
        retry: 'Повторить',
        loading: 'Загрузка...',
      },
      app: {
        title: 'Trio Waiter',
        summary:
          'Отдельный mobile-first инструмент для управления QR-кодами столов для сотрудников ресторана.',
        onlineReady:
          'Соединение доступно. Управление QR готово к онлайн-работе.',
        offlineMessage: 'Для управления QR-кодами нужно подключение.',
        offlineSubMessage:
          'Приложение возобновит работу после восстановления связи.',
      },
      language: {
        label: 'Язык',
        option: {
          hy: 'Հայերեն',
          en: 'English',
          ru: 'Русский',
        },
      },
      home: {
        title: 'Выберите организацию',
        manageAction: 'Управлять',
        doneAction: 'Готово',
        removeAction: 'Удалить сохраненный вход',
        managingHint:
          'Перетащите маркер, чтобы изменить порядок входов, или используйте клавиши со стрелками. Нажмите кнопку корзины, чтобы удалить вход.',
        managingSingleHint: 'Нажмите кнопку корзины, чтобы удалить этот вход.',
        removeConfirmationSheet: {
          title: 'Удалить сохраненный вход?',
          description:
            'Удалить {{organizationName}} · {{operatorName}} только с этого устройства?',
          cancelAction: 'Отмена',
          removeAction: 'Удалить',
        },
        description:
          'Сохраненные входы остаются на этом устройстве.\nЧтобы продолжить, всё ещё нужен PIN.',
        languageSwitchAriaLabel: 'Сменить язык на {{language}}',
        savedLoginCard: {
          ariaLabel: 'Открыть вход {{organizationName}}',
          checkingStatus: 'Проверка сохраненного входа...',
          invalidMessage:
            'Этот сохраненный вход больше недействителен. Отсканируйте новый QR входа, чтобы использовать эту организацию снова.',
          invalidScanAction: 'Сканировать новый QR входа',
          invalidRemoveAction: 'Удалить',
          lockedStatus: 'Заблокирован {{time}}',
          reorderAction: 'Изменить порядок входа {{organizationName}}',
          reorderHint:
            'Перетащите или используйте клавиши со стрелками вверх и вниз',
          movedAnnouncement:
            '{{organizationName}} перемещена на позицию {{position}} из {{total}}.',
        },
        addLoginCard: {
          title: 'Добавить ещё вход',
          subtitle: 'Сканировать QR-код',
          ariaLabel: 'Добавить ещё вход и сканировать QR-код',
        },
        empty: {
          title: 'Нет сохраненных входов',
          description:
            'Отсканируйте QR входа оператора, чтобы добавить организацию на этом устройстве.',
        },
        tables: {
          title: 'Столы',
          hallsLabel: 'Залы',
          findByQrAction: 'Найти стол по QR',
          findScannerSubtitle: 'Поиск стола',
          findScannerInstruction: 'Сканируйте QR стола',
          findScannerDescription: 'Стол будет выбран в своем зале.',
          invalidFindQr: 'Это не QR стола.',
          qrTableNotFound: 'К этому QR не привязан стол.',
          noQrAttached: 'QR не присоединен',
          loading: 'Столы загружаются...',
          tableNoLongerExists:
            'Этот стол больше недоступен. Список столов обновлен.',
          noTablesFound: 'Столы не найдены',
          attachedQrs: 'Присоединенные QR',
          attachedQrListAriaLabel: 'Присоединенные QR столов',
          qrImageAriaLabel: 'QR-код {{sequenceNumber}}',
          detailBackAction: 'Назад к столам',
          removeAction: 'Удалить',
          removeQrAriaLabel: 'Удалить QR {{sequenceNumber}}',
          attachAction: 'Присоединить QR',
          dismissNoticeAction: 'Закрыть статус',
          attachSuccess: 'QR {{sequenceNumber}} присоединен к {{tableName}}',
          invalidTableQr: 'Это не QR стола.',
          invalidTableQrDescription:
            'Отсканируйте QR, созданный для настройки столов.',
          alreadyAttached:
            'QR {{sequenceNumber}} уже присоединен к этому столу.',
          alreadyAttachedDialog: {
            title: 'QR {{sequenceNumber}} уже на столе {{tableName}}',
            description: 'Изменений не было.',
            acknowledgeAction: 'Понятно',
          },
          moveConfirmationSheet: {
            title: 'Переместить QR {{sequenceNumber}}?',
            alreadyAttachedDescription:
              'Этот QR уже присоединен к другому столу.',
            message:
              'Удалить QR {{sequenceNumber}} из {{fromHallName}} / {{fromTableName}} и присоединить к {{toHallName}} / {{toTableName}}?',
            fromLabel: '{{fromHallName}} / {{fromTableName}}',
            fromHeading: 'Откуда',
            summaryLabel: 'Сводка перемещения',
            toLabel: '{{toHallName}} / {{toTableName}}',
            toHeading: 'Куда',
            cancelAction: 'Отмена',
            moveAction: 'Переместить QR',
          },
          moveConflictSheet: {
            title: 'QR {{sequenceNumber}} не был перемещён',
            description:
              'Привязка изменилась, пока вы работали. Сейчас QR {{sequenceNumber}} привязан к {{tableName}}. Загружены актуальные данные столов.',
            changedBy: 'Последнее изменение: {{userName}}',
            changedAt: 'Время последнего изменения: {{dateTime}}',
            acknowledgeAction: 'Понятно',
          },
          removeConfirmationSheet: {
            title: 'Удалить QR {{sequenceNumber}} из {{tableName}}?',
            description:
              'Этот QR будет отвязан от стола и позже его можно будет присоединить снова.',
            cancelAction: 'Отмена',
            removeAction: 'Удалить',
          },
          removeSuccess: 'QR {{sequenceNumber}} удалён из {{tableName}}',
          removeFailed: 'Не удалось удалить QR. Повторите попытку.',
          moveSuccess:
            'QR {{sequenceNumber}} перемещен из {{fromTableName}} в {{toTableName}}',
          moveFailed: 'Не удалось переместить QR. Повторите попытку.',
          moveConflict: 'Привязка QR изменилась. Данные стола обновлены.',
          openTableAriaLabel: 'Открыть {{tableName}}',
          hallTabsAriaLabel: 'Выбрать зал',
          tableListAriaLabel: 'Столы {{hallName}}',
        },
        scanner: {
          closeAction: 'Закрыть сканер',
          scanLoginHint: 'Наведите камеру на QR.',
          loginHeaderSubtitle: 'Вход оператора настройки',
          tableHeaderSubtitle: 'Привязать к столу',
          tableContextLabel: 'Привязать к {{hallName}} · {{tableName}}',
          loginTitle: 'Сканируйте QR входа',
          loginDescription:
            'Сканируйте QR входа оператора из административной системы ресторана.',
          loginInstructionTitle: 'Поместите один QR входа в рамку.',
          loginInstructionText: 'Сканирование завершится автоматически.',
          tableTitle: 'Сканируйте QR стола',
          tableDescription: 'Наведите камеру на физический QR стола.',
          tableInstructionTitle: 'Поместите один QR стола в рамку.',
          tableInstructionText: 'Сканирование завершится автоматически.',
          detectedChecking: 'QR распознан · Проверяем…',
          detectedCheckingDescription: 'Держите QR-код внутри рамки.',
          errorInstructionText: 'Сканируйте правильный QR настройки.',
          invalidLoginQrDescription: 'Сканируйте QR из админ-приложения.',
          loginCameraNeededText:
            'Разрешите доступ к камере, чтобы сканировать QR входа оператора.',
          tableCameraNeededText:
            'Разрешите доступ к камере, чтобы сканировать QR столов.',
          backAction: 'Выберите организацию',
          invalidLoginQr: 'Это не QR входа.',
          cameraNeededTitle: 'Нужен доступ к камере',
          cameraNeededText:
            'Разрешите камеру для сканирования QR входа и столов.',
          cameraFrozenTitle: 'Предпросмотр камеры завис',
          cameraFrozenText:
            'Закройте другие приложения, использующие камеру, и повторите попытку.',
          tryAgain: 'Повторить',
          flashlightOn: 'Включить фонарик',
          flashlightOff: 'Выключить фонарик',
          cameraZoom: 'Масштаб камеры',
          cameraZoomValue: '{{value}}×',
          cameraZoomAction:
            'Масштаб камеры: {{value}}. Нажмите, чтобы сбросить.',
        },
        pin: {
          title: 'Введите <strong>PIN</strong>',
          signedInAs: '{{name}} · {{organizationName}}',
          changeAction: 'Сменить организацию',
          scanAgainAction: 'Сканировать снова',
          label: 'PIN',
          verifying: 'Проверка...',
          successMessage: 'Сеанс настройки QR начался.',
          invalidError:
            'Неверный PIN. Попытка {{attempt}}/3. Осталось {{remaining}} попыток.',
          lockedError:
            'Слишком много неверных попыток PIN. Попробуйте снова через {{time}}.',
          pinDigitLabel: 'Цифра PIN {{index}}',
          pinComponentLabel: '4-значный PIN',
          continueAutomatically: 'Вы продолжите автоматически',
          firstRun: {
            subtitle: 'Войти как {{name}}',
          },
          repeat: {
            subtitle: 'Вход как {{name}}',
          },
        },
        logoutLabel: 'Выйти',
        sessionVerifying: 'Проверка сессии...',
        loginQrVerifying: 'Проверка QR входа...',
        sessionExpired: 'Сессия истекла. Пожалуйста, войдите снова.',
      },
      notFound: {
        title: 'Страница не найдена',
        description: 'Проверьте адрес или вернитесь на стартовую страницу.',
      },
    },
  },
} as const;
